import { STR_ERRORS } from "../../Strings";
const deviceTypeToClientType = {
    IsNativeApp: "MobileApp",
    IsMobile: "Mobile",
    IsTablet: "Tablet",
    IsDesktop: "Website"
};
export function getClientType(type) {
    if (typeof type === "undefined" || typeof deviceTypeToClientType[type] === "undefined") {
        console.error(STR_ERRORS.NoDeviceType);
        return;
    }
    return deviceTypeToClientType[type];
}
//# sourceMappingURL=GetClientType.js.map